import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => (
  <SvgIcon>
    <svg fill="none">
      <path
        d="M3 9.80204C3 9.22624 3.24817 8.67838 3.681 8.29864L10.681 2.15722C11.4357 1.4951 12.5643 1.4951 13.319 2.15722L20.319 8.29864C20.7518 8.67838 21 9.22624 21 9.80204V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V9.80204Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M12 10V15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M9.5 12.5H14.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  </SvgIcon>
);
